import {addEvent} from '../add-event'

export function logoutEvent(): boolean {
    return addEvent('logout', 'Menu')
}
